/* eslint-disable react/prop-types */
import React from 'react';
import { makeStyles } from '@material-ui/styles';

const useStyle = makeStyles((theme) => ({
    container: {
        maxWidth: '100%',
        display: 'flex',
        flexDirection: 'row',
        // border: '1px solid rgba(0,0,0,.1)',
        borderLeft: '1px solid rgba(0,0,0,.1)',
        borderBottom: '1px solid rgba(0,0,0,.1)',
        justifyContent: 'center',
        overflow: 'auto',
        borderRadius: '8px',
        marginBottom: '24px',
        // '&:last-child': { borderRight: 'none' },
        [theme.breakpoints.down(1025)]: {
            borderRadius: '0'
        }
    },
    item: ({ isFirstColumn }) => ({
        display: 'flex',
        flexDirection: 'column',
        minWidth: isFirstColumn ? 150 : 250,
        overflow: 'hidden',
        position: isFirstColumn ? 'sticky' : undefined,
        left: isFirstColumn ? 0 : undefined,
        zIndex: isFirstColumn ? 1 : undefined
    }),
    title: ({ isFirstColumn }) => ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: 150,
        minHeight: 35,
        background: '#416ce1',
        color: 'white',
        borderBottom: isFirstColumn ? '1px solid #eaeaea#' : undefined,
        position: isFirstColumn ? 'sticky' : undefined,
        left: isFirstColumn ? 0 : undefined,
        zIndex: isFirstColumn ? 1 : undefined
    }),
    value: ({ isFirstColumn }) => ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: 150,
        minHeight: 35,
        borderRight: `1px solid #eaeaea`,
        borderTop: '1px solid rgba(0,0,0,0.05)',
        position: isFirstColumn ? 'sticky' : undefined,
        left: isFirstColumn ? 0 : undefined,
        zIndex: isFirstColumn ? 1 : undefined,
        background: 'white'
    })
}));
/**
 *
 * @param {{children: string,scrollLeft: number | string} & HTMLDivElement} param0
 */
// eslint-disable-next-line react/prop-types
export default function Table({ children, innerRef, ...props }) {
    const classes = useStyle();

    return (
        // eslint-disable-next-line react/prop-types
        <div {...props} className={`${classes.container} ${props.className}`} ref={innerRef}>
            {children}
        </div>
    );
}

export function TableItem({ children, isFirstColumn = false, className = '', ...props }) {
    const classes = useStyle({ isFirstColumn });

    return (
        <div {...props} className={`${classes.item} ${className}`}>
            {children}
        </div>
    );
}

// eslint-disable-next-line react/prop-types
export function TableItemHeader({ children, isFirstColumn = false, className = '' }) {
    const classes = useStyle({ isFirstColumn });

    return <div className={`${classes.title}  ${className}`}>{children}</div>;
}

// eslint-disable-next-line react/prop-types
export function TableItemValue({ children, isFirstColumn = false, className = '' }) {
    const classes = useStyle({ isFirstColumn });

    return <div className={`${classes.value}  ${className}`}>{children}</div>;
}
